// src/pages/Home/components/ui/SoonPopup.jsx
import React from "react";

export default function SoonPopup({ open, lang }) {
  if (!open) return null;

  return (
    <div className="aq-popup" role="status" aria-live="polite">
      <div className="aq-popup-inner">
        <span className="aq-popup-dot" aria-hidden="true" />
        <span className="aq-popup-text">{lang === "ar" ? "قريباً" : "Coming soon"}</span>
      </div>
    </div>
  );
}
